import { DataLakeEnums } from 'dashboard-services/api/dataLake';

import { filesDatalakeActions } from 'actions/modules/datalake';

const FORWARD_CURVE_METADATA = filesDatalakeActions.FORWARD_CURVE_METADATA

export const updateForwardCurveMetadataField = ({ fields = [], shouldBeForwardCurvesGroup }) => {
  const hasForwardCurveMetadata = fields.some(field => field.name === FORWARD_CURVE_METADATA)
  if(shouldBeForwardCurvesGroup && !hasForwardCurveMetadata) {
    return fields.concat({
      name: FORWARD_CURVE_METADATA,
      type: DataLakeEnums.GROUP_FIELD_TYPE.TEXT,
      defaultValue: String(true)
    })
  }
  if(!shouldBeForwardCurvesGroup && hasForwardCurveMetadata) {
    return fields.filter(field => field.name !== FORWARD_CURVE_METADATA)
  }
  return fields
}
